module.exports = __webpack_public_path__ + "static/media/Icon Alert Filled.78dfb12c.svg";